

import { createSlice } from '@reduxjs/toolkit'

export const initialLoaderState = {
  // Initial Loader State
  counter: 0,
  isComplete: false,
}

export const loaderSlice = createSlice({
  name: 'loader',
  initialState: initialLoaderState,
  reducers: {
    incrementLoadingCounter: (state) => {
      const remaining = 100 - state.counter

      state.counter = Math.min(99, state.counter + (0.015 * Math.pow(1 - Math.sqrt(remaining), 2)))
    },
    resetLoadingState: (state) => {
      state.counter = 0
      state.isComplete = false
    },
    completeLoadingState: (state) => {
      state.counter = 100
      state.isComplete = true
    },
  },
})

export const {
  incrementLoadingCounter,
  resetLoadingState,
  completeLoadingState,
} = loaderSlice.actions
